"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PonziRuleCreateButton = exports.PONZI_RULE_UPLOAD_DIALOG_KEY = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const icons_material_1 = require("@mui/icons-material");
const react_hooks_1 = require("@dzambalaorg/react-hooks");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const mui_inputs_asset_1 = require("@dzambalaorg/mui-inputs-asset");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const setRules_json_1 = __importDefault(require("@framework/abis/json/Ponzi/setRules.json"));
const provider_api_firebase_1 = require("@dzambalaorg/provider-api-firebase");
const upload_dialog_1 = require("./upload-dialog");
exports.PONZI_RULE_UPLOAD_DIALOG_KEY = Symbol("ponziRuleUpload");
const PonziRuleCreateButton = (props) => {
    const { className, disabled, variant = styled_1.ListActionVariant.button } = props;
    const { openFormDialog, formDialogUniqueKey, mode } = (0, react_hooks_1.useDialogForm)();
    const api = (0, provider_api_firebase_1.useApi)();
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const handleUpload = () => {
        openFormDialog(exports.PONZI_RULE_UPLOAD_DIALOG_KEY, void 0, "button");
    };
    // MODULE:MYSTERYBOX
    const { execute: metaLoadRule } = (0, react_hooks_eth_1.useMetamask)(async (rule, _content) => {
        const ponziRule = {
            deposit: rule.deposit?.components.map(component => ({
                tokenType: Object.values(types_1.TokenType).indexOf(component.tokenType),
                token: component.contract.address,
                tokenId: component.templateId || 0,
                amount: component.amount,
            }))[0],
            reward: rule.reward
                ? rule.reward.components.map(component => ({
                    tokenType: Object.values(types_1.TokenType).indexOf(component.tokenType),
                    token: component.contract.address,
                    tokenId: component.templateId,
                    amount: component.amount,
                }))
                : {
                /* empty asset */
                },
            terms: {
                period: rule.durationAmount, // todo fix same name // seconds in days
                penalty: rule.penalty || 0,
                maxCycles: rule.maxCycles,
            },
            active: true, // todo add var in interface
        };
        return writeContractAsync({
            address: rule.contract.address,
            abi: setRules_json_1.default,
            functionName: "setRules",
            args: [[ponziRule]],
        });
    });
    const handleLoadRule = async ({ data: rule }) => {
        // MODULE:MYSTERYBOX
        const content = [];
        if (rule.reward) {
            for (const row of rule.reward.components) {
                if (row.templateId) {
                    const { rows: [mysteryBox], } = await api.fetchJson({
                        url: "/mystery/boxes",
                        method: "GET",
                        data: { templateIds: [row.templateId] },
                    });
                    // MODULE:MYSTERYBOX
                    if (mysteryBox) {
                        content.push(mysteryBox.content.components.map(component => ({
                            tokenType: Object.values(types_1.TokenType).indexOf(component.tokenType),
                            token: component.contract.address,
                            tokenId: component.templateId || 0,
                            amount: component.amount,
                        })));
                    }
                    else {
                        content.push([]);
                    }
                }
            }
            if (!content.length)
                content.push([]);
        }
        else {
            content.push([]);
        }
        await metaLoadRule(rule, content);
    };
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleUpload, icon: icons_material_1.Add, message: "form.buttons.create", className: className, dataTestId: "PonziRuleUploadButton", disabled: disabled, variant: variant }), (0, jsx_runtime_1.jsx)(upload_dialog_1.PonziRuleUploadDialog, { onExternalConfirm: handleLoadRule, open: formDialogUniqueKey === `${exports.PONZI_RULE_UPLOAD_DIALOG_KEY}.${mode}`, initialValues: {
                    deposit: mui_inputs_asset_1.emptyPrice,
                    reward: mui_inputs_asset_1.emptyPrice,
                    durationAmount: 2592000,
                    durationUnit: types_1.DurationUnit.DAY,
                    penalty: 100,
                    maxCycles: 0,
                } })] }));
};
exports.PonziRuleCreateButton = PonziRuleCreateButton;
//# sourceMappingURL=index.js.map